import { render, staticRenderFns } from "./AccProductPage.vue?vue&type=template&id=777dd1f6&"
import script from "./AccProductPage.vue?vue&type=script&lang=js&"
export * from "./AccProductPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports